import { render, staticRenderFns } from "./MangheOrder.vue?vue&type=template&id=3a654798&scoped=true&"
import script from "./MangheOrder.vue?vue&type=script&lang=js&"
export * from "./MangheOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a654798",
  null
  
)

export default component.exports